import { render, staticRenderFns } from "./SupervisorList.vue?vue&type=template&id=4ba7ff26&scoped=true&"
import script from "./SupervisorList.vue?vue&type=script&lang=js&"
export * from "./SupervisorList.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorList.vue?vue&type=style&index=0&id=4ba7ff26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7ff26",
  null
  
)

export default component.exports